class AnimateIn extends HTMLElement {
  connectedCallback () {
    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) {
      this.style.opacity = 1

      return
    }

    if (this.dataset.runInstant === 'true') {
      setTimeout(() => {
        this.setAttribute('animate', '')
      }, 500)
    } else {
      const amountIntoViewport = this.hasAttribute('data-animate-earlier')
        ? window.innerWidth >= 768
          ? '-150px'
          : '-50px'
        : window.innerWidth >= 768
          ? '-250px'
          : '-80px'

      // eslint-disable-next-line compat/compat
      this.observer = new IntersectionObserver(this.onEntry.bind(this), {
        rootMargin: amountIntoViewport,
        threshold: 0,
      })
      // We need to observe the video element as the host element has display: contents on it. IntersectionObserver won't work on an element that is set to display: contents
      this.observer.observe(this)
    }
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    this.setAttribute('animate', '')

    observer.unobserve(this)
  }
}

if (!customElements.get('animate-in')) {
  customElements.define('animate-in', AnimateIn)
}
